import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AddIcon,
  Card,
  Heading,
  ListItem,
  Pane,
  UnorderedList,
  SearchInput,
  Spinner,
} from 'evergreen-ui';
import simboloVitaResize from '../../assets/simboloVitaResize.png';
import LoadingOverlay from '../../shared/LoadingOverlay';
import { useQueryVitaUserByIdentityId } from '../../services/api/vitaUserService';
import { toastNotification } from '../../shared/toastNotification';
import CreateCompanyForm from './CreateCompanyForm';
import { mutate } from 'swr';
import { useDispatch } from 'react-redux';
import { reconciliationValuesActions } from '../../store/reconciliationValues';
import { useQueryUserRolesCurrentRole } from '../../services/api/userRolesService';

function SwitchCompanyPage() {
  const companyId = localStorage.getItem('companyId');
  const userId = localStorage.getItem('userId');
  const [searchQuery, setSearchQuery] = useState('');
  const [isShownDialog, setIsShownDialog] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const openDialog = (user) => {
    setIsShownDialog(true);
    setCurrentUser(user);
  };

  let statusResponse = false;
  let toastContent = '';

  const navigate = useNavigate();

  const {
    data: vitaUser,
    isLoading: isLoadingVitaUser,
    isError: isErrorVitaUser,
  } = useQueryVitaUserByIdentityId(userId, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const chooseCompany = async (company) => {
    setIsLoading(true);
    console.log('choose company: ', company.name);

    localStorage.setItem('companyId', company.id);
    localStorage.setItem('companyName', company.name);
    statusResponse = 'success';
    toastContent = `${company.name} selecionada`;

    await Promise.all([
      mutate('entriesFilteredByDate'),
      mutate('bankBalances'),
      mutate('userRolesCurrentRole'),
    ]);

    dispatch(reconciliationValuesActions.resetFilter());
    toastNotification(statusResponse, toastContent);
    navigate('/lancamentos');
  };

  useEffect(() => {
    if (!isLoadingVitaUser && !vitaUser?.data?.signedTerm) {
      navigate('/termos-de-uso');
      console.log('navigate to termos de uso');
    }
  }, [companyId, userId, vitaUser]);

  if (isLoadingVitaUser) {
    return <LoadingOverlay />;
  }

  const filteredAndSortedCompanies = vitaUser?.data?.companies
    ?.filter((company) => company.name.toLowerCase().includes(searchQuery.toLowerCase()))
    ?.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Pane
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      gap={32}
      alignItems="center"
      justifyContent="flex-start"
      padding={32}
      backgroundImage="radial-gradient(circle, rgba(232,238,248,1) 8%, rgba(195,207,226,1) 91%)"
    >
      <CreateCompanyForm isShown={isShownDialog} setIsShown={setIsShownDialog} />

      <img
        src={simboloVitaResize}
        height="20%"
        style={{
          maxWidth: '200px',
          filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))',
          marginTop: '40px',
        }}
      />

      <Heading size={900} marginY={16} textAlign="center" color="#234361" fontWeight={600}>
        Selecione a empresa
      </Heading>

      <SearchInput
        width="100%"
        maxWidth={400}
        height={40}
        placeholder="Buscar empresa..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        marginBottom={16}
      />

      <Pane
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        flexWrap="wrap"
        gap={16}
        width="100%"
        maxWidth={1200}
        padding={16}
      >
        {!isLoadingVitaUser && vitaUser?.data?.isClient && (
          <Card
            className="company-card new-company"
            display="flex"
            position="relative"
            elevation={2}
            width={280}
            height={120}
            backgroundColor="white"
            padding={24}
            alignItems="center"
            justifyContent="center"
            onClick={openDialog}
            cursor="pointer"
            transition="all 0.2s ease-in-out"
          >
            <UnorderedList size={600}>
              <ListItem icon={AddIcon} color="#47B881" fontSize={16} fontWeight={500}>
                Criar nova empresa
              </ListItem>
            </UnorderedList>
          </Card>
        )}

        {!isLoadingVitaUser &&
          !isErrorVitaUser &&
          filteredAndSortedCompanies?.map((company) => (
            <Card
              key={company.id}
              className="company-card"
              display="flex"
              elevation={2}
              width={280}
              height={120}
              backgroundColor="white"
              padding={24}
              alignItems="center"
              justifyContent="center"
              cursor={isLoading ? 'wait' : 'pointer'}
              onClick={() => !isLoading && chooseCompany(company)}
              transition="all 0.2s ease-in-out"
              position="relative"
              textAlign="center"
            >
              {isLoading ? (
                <Spinner size={24} />
              ) : (
                <Heading
                  size={600}
                  color="#234361"
                  textAlign="center"
                  width="100%"
                  wordWrap="break-word"
                >
                  {company.name}
                </Heading>
              )}
            </Card>
          ))}
      </Pane>

      <style jsx="true">{`
        .company-card {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
        }

        .company-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .new-company {
          border: 2px dashed #e4e7eb;
          background-color: #f9fafc;
        }

        .new-company:hover {
          border-color: #47b881;
          background-color: #f5faf8;
        }
      `}</style>
    </Pane>
  );
}

export default SwitchCompanyPage;
